<template>
    <div class="container-fluid">
        <slot name="subnav"></slot>

        <div class="main--content container">
            <slot></slot>
        </div>
    </div>
</template>

<script>
	export default {
		name: "MainContainer"
	}
</script>
